import { CoursesService } from "~/entity/Courses/api/service";
import { useGetAllCoursesForSelect } from "~/entity/Courses/hooks/useGetAllCoursesForSelect";

export const useCourses = () => {
  const coursesGet = CoursesService.GET.getCourses;
  const coursesGetSingle = CoursesService.GET.getCoursesSingle;
  const getExpectationsSingle = CoursesService.GET.getExpectationsSingle;
  const getLevels = CoursesService.GET.getLevels;
  const coursesCreate = CoursesService.POST.createCourses;
  const coursesPut = CoursesService.PUT.putCourses;
  const coursesSelect = useGetAllCoursesForSelect;

  return {
    coursesGet,
    coursesCreate,
    coursesGetSingle,
    getLevels,
    coursesPut,
    coursesSelect,

    getExpectationsSingle,
  };
};
